import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Form, Button, Icon, Card, Modal, message } from "antd";
import { OrderedMap, Map, List } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import {
    INPUT_TYPES, RECOURSE_STRUCTURE,
    SECURITY_TYPES, SECURITY_BASIS
} from "constants/index";
import "styles/tabs.css";

const getFormFields = ({
    allFieldsDisabled,
}) =>
    new OrderedMap({
        recourse_structure: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Recourse Structure",
            options: RECOURSE_STRUCTURE.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            rules: [
                {
                    required: true,
                    message: "Field is required"
                },

            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        recourse_perc: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.TEXT,
            label: "Recourse %",
            rules: [
                {
                    required: true,
                    message: "Field is required"
                },
                {
                    pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                    message: "Input must be between 0 and 100"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        days_of_guarantee_invocation: {
            className: "form-field fb-30 mr-3perc",
            label: "Days of Guarantee Invocation",
            type: INPUT_TYPES.TEXT,
            // disabled: true,
            category: 1,
            col: 8
        },
        security_type: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Security Type",
            options: SECURITY_TYPES.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        security_basis: {
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.SELECT,
            label: "Security Basis",
            options: SECURITY_BASIS.map((value, label) => ({
                label,
                value: String(value)
            }))
                .toList()
                .toArray(),
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        effective_date: {
            key: "effective_date",
            label: "Effective Date",
            disabled: false,
            dataIndex: "effective_date",
            type: INPUT_TYPES.DATE,
            className: "form-field fb-30 mr-3perc",
            col: 8
        },
        holdback_calculation_type: {
            label: "Holdback Type",
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.RADIO,
            defaultValue: 1,
            options: [
                {
                    key: "security_perc",
                    value: 2,
                    label: "Holdback %"
                },
                {
                    key: "security_amount",
                    value: 1,
                    label: "Holdback Amount"
                }
            ],
            col: 8
        },
        security_perc: {
            key: "security_perc",
            label: "Holdback %",
            disabled: true,
            dataIndex: "security_perc",
            type: INPUT_TYPES.NUMBER,
            className: "form-field fb-30 mr-3perc w-100",
            rules: [
                {
                    pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                    message: "Input must be between 0 and 100"
    }
            ],
            col: 8
        },
        security_amount: {
            key: "security_amount",
            label: "Holdback Amount",
            dataIndex: "security_amount",
            type: INPUT_TYPES.NUMBER,
            disabled: true,
            className: "form-field fb-30 mr-3perc",
            col: 8
        },
        is_churns_applicable: {
            key: "is_churns_applicable",
            dataIndex: "is_churns_applicable",
            className: "form-field fb-30 mr-3perc",
            type: INPUT_TYPES.RADIO,
            label: "Churns Applicable",
            options: [
                {
                    key: "Yes",
                    value: true,
                    label: "Yes"
                },
                {
                    key: "No",
                    value: false,
                    label: "No"
                }
            ],
            rules: [
                {
                    required: true,
                    message: "Field is Required"
                }
            ],
            disabled: allFieldsDisabled,
            category: 1,
            col: 8
        },
        number_of_churns: {
            className: "form-field fb-30 mr-3perc",
            label: "No. of Churns",
            type: INPUT_TYPES.TEXT,
            // disabled: true,
            category: 1,
            col: 8
        },
        pre_churn_db_security_perc: {
            className: "form-field fb-30 mr-3perc",
            label: "Pre Churn DB Security",
            type: INPUT_TYPES.TEXT,
            // disabled: true,
            category: 1,
            col: 8
        },
    });

class RetailerRiskControlForm extends React.Component {

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        // e.preventDefault();
        this.props.form.validateFields((err, restValues) => {
            if(!err) {
                const recourse_structure = !isNaN(restValues.recourse_structure) ? Number(restValues.recourse_structure)
                    : RECOURSE_STRUCTURE.get(restValues.recourse_structure);
                // const security_type = SECURITY_TYPES.get(restValues.security_type);
                const security_basis = !isNaN(restValues.security_basis)
                    ? Number(restValues.security_basis)
                    : SECURITY_BASIS.get(restValues.security_basis);
                const mpa_approval_id = Array.isArray(this.props.retailerRiskControlData) ? this.props.retailerRiskControlData[0]?.id : null;
                const retailerPostData = {
                        "mpa_approval_id" : mpa_approval_id,
                    "company_id": this.props.companyId,
                    ...restValues,
                    recourse_structure,
                    // security_type,
                    security_basis,
                    effective_date: restValues.effective_date ? moment(restValues.effective_date).format("YYYY-MM-DD") : null,
                }
                
                this.props.onValuesSubmit(retailerPostData);
            }
        });
        // }
    };

    formFields = getFormFields({
        allFieldsDisabled: this.props.loading,
    });

    handleFieldValueChange = (fieldName, value) => {
        if(fieldName == "security_type" && value == 5){
            this.props.form.setFieldsValue({
                security_perc: null,
                security_amount: null,
            })
        }

        if (fieldName == "holdback_calculation_type") {
            this.props.form.setFieldsValue({
                security_perc: null,
                security_amount: null,
            })
        }

        if (fieldName == 'is_churns_applicable') {
            this.props.form.setFieldsValue({
                number_of_churns: null,
                pre_churn_db_security_perc: null,
            })
        }
        if (fieldName == 'recourse_structure') {
            if(value == 1){
                this.props.form.setFieldsValue({
                    is_churns_applicable: false,
                })
            }else if(value == 2){
                this.props.form.setFieldsValue({
                    is_churns_applicable: true,
                })
            }else if(value == 3){
                this.props.form.setFieldsValue({
                    recourse_perc: null,
                })
            }else if(value == 4){
                this.props.form.setFieldsValue({
                    recourse_perc: null,
                    pre_churn_db_security_perc: null
                })
            }else if (value == 5) {
                this.props.form.setFieldsValue({
                    recourse_perc: '100',
                    pre_churn_db_security_perc: null,
                    is_churns_applicable : false
                })
            }
        }
        if(fieldName == 'recourse_perc' && [4,5].includes(this.props.form.getFieldValue('recourse_structure'))){
            this.props.form.setFieldsValue({
                pre_churn_db_security_perc: null,
            })
        }
    }


    getCompanyForm = () => (
        <Card className={"no-shadow border-none"}>
            <div className={"d-flex flex-row align-items-center flex-wrap w-100"}>
                {this.formFields.map((field, fieldName) => {
                    // field.disabled = this.props.disableFields;
                    const recourse_structure = this.props.form.getFieldValue("recourse_structure");
                    const recourse_perc_value = this.props.form.getFieldValue("recourse_perc");
                    if (fieldName == "holdback_calculation_type") {
                        const security_type = this.props.form.getFieldValue("security_type");
                        if (security_type == 5) {
                            field.disabled = true;
                        }
                    }
                    if (fieldName == "security_perc") {
                        const holdback_calculation_type = this.props.form.getFieldValue("holdback_calculation_type");
                        const security_type = this.props.form.getFieldValue("security_type");
                        if (holdback_calculation_type == 2) {
                            field.disabled = false;
                            field.rules = [
                                {
                                    required: true,
                                    message: "Field is Required"
                                },
                                {
                                    pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                    message: "Input must be between 0 and 100"
                                }
                            ];
                        } else {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];
                        }
                        if (security_type == 5) {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];
                        }
                    }
                    if (fieldName == "security_amount") {
                        const holdback_calculation_type = this.props.form.getFieldValue("holdback_calculation_type");
                        const security_type = this.props.form.getFieldValue("security_type");

                        if (holdback_calculation_type == 2) {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];
                        } else {
                            field.disabled = false;
                            field.rules = [
                                {
                                    required: true,
                                    message: "Field is Required"
                                }, {
                                    pattern: /^(?:\d*\.)?\d+$/,
                                    message: "Please enter a valid number"
                                }
                            ];
                        }
                        if (security_type == 5) {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];
                        }
                    }
                    if (['number_of_churns'].includes(fieldName)) {
                        const is_churns_applicable = this.props.form.getFieldValue("is_churns_applicable");
                        if (is_churns_applicable) {
                            field.disabled = false;
                            field.rules = [
                                {
                                    required: true,
                                    message: "Field is Required"
                                },
                                {
                                    pattern: /^(?:\d*\.)?\d+$/,
                                    message: "Please enter a valid number"
                                }
                            ];
                        } else {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];

                        }
                    }
                    if (['pre_churn_db_security_perc'].includes(fieldName)) {
                        const is_churns_applicable = this.props.form.getFieldValue("is_churns_applicable");
                        if (is_churns_applicable) {
                            field.disabled = false;
                            field.rules = [
                                {
                                    required: true,
                                    message: "Field is Required"
                                },
                                {
                                    pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                    message: "Input must be between 0 and 100"
                                }
                            ];
                        } else {
                            field.disabled = true;
                            field.rules = [{
                                required: false
                            }];

                        }
                    }

                    if (fieldName === "recourse_perc") {
                        const recourse_structure = this.props.form.getFieldValue("recourse_structure");
                        field.type = INPUT_TYPES.TEXT;
                        field.disabled = false;
                        field.rules = [
                            {
                                required: true,
                                message: "Field is required"
                            },
                            {
                                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                message: "Input must be between 0 and 100"
                            }
                        ];

                        if (recourse_structure == 3) {
                            field.disabled = true;
                            field.rules = [{ required: false }];
                        }

                        if (recourse_structure == 4) {
                            field.type = INPUT_TYPES.SELECT;
                            field.options = Array.from({ length: 10 }, (_, i) => ({
                                label: `${(i + 1) * 10}`,
                                value: (i + 1) * 10
                            }));
                        }
                    }

                    // if (fieldName === "effective_date") {
                    //     const recourse_structure = this.props.form.getFieldValue('recourse_structure');
                    //     if (recourse_structure == "100-0 Risk Sharing" || recourse_structure == 5) {
                    //         field.disabled = false
                    //         field.rules = [{ required: true }];
                    //     } else {
                    //         field.disabled = true
                    //         field.rules = [{ required: false }];
                    //     }
                    // }
                    if (fieldName == "pre_churn_db_security_perc") {
                        field.type = INPUT_TYPES.INPUT;
                        field.options = undefined;
                        if (recourse_structure == 4) {
                            field.type = INPUT_TYPES.SELECT;
                            const startValue = Math.ceil((recourse_perc_value + 1) / 10) * 10;
                            if (recourse_perc_value) {
                                field.options = Array.from({ length: (100 - startValue) / 10 + 1 }, (_, i) => ({
                                    label: (startValue + (i * 10)).toString(),
                                    value: startValue + (i * 10)
                                }));
                            }
                        } else {
                            field.type = INPUT_TYPES.TEXT;
                            field.options = [];
                        }
                    }
                    // }
                    
                    const value = this.props.values && this.props.values[fieldName];
                    return this.fieldGenerator(
                        fieldName,
                        field,
                        this.getValidateStatus(fieldName),
                        (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e :  e.target.value)),
                        true
                    )();
                }).toList()}
            </div>
        </Card>
    );

    render() {
        return (
            <React.Fragment>
                <Form>
                    <div className={"form-row align-items-center"}>    
                        <div className={"w-100 pt-10"}>
                            <h3 className={"pt-5 pb-5"}>{"Company Background"}</h3>
                            <h4 className={"pt-5 pb-5"}>{"Promoter and Company Information"}</h4>
                            {this.getCompanyForm()}
                        </div>
                    </div>
                    {/* {!this.props.disableFields ? ( */}
                        <div className={"d-flex flex-row-reverse"}>
                            <Form.Item>
                                <Button disabled={this.props.disableFields} type="primary" block className={"mt-10"} onClick={(e) => this.onValuesSubmit(e)}>Submit</Button>
                            </Form.Item>
                        </div>
                    {/* ) : null} */}
                </Form>
            </React.Fragment>
        );
    }
}

RetailerRiskControlForm.propTypes = {
    form: PropTypes.object,
    onValuesSubmit: PropTypes.func,
    disableFields: PropTypes.bool,
    companyId: PropTypes.string,
};

export default Form.create({
    mapPropsToFields: ({ retailerRiskControlData }) => {
        const retailerRiskControlDataNew=Array.isArray(retailerRiskControlData) ? retailerRiskControlData[0] : retailerRiskControlData;
        if (!retailerRiskControlDataNew) {
            return {};
        }
        return Object.entries(retailerRiskControlDataNew).reduce((acc, [key, fieldValue]) => {
            let transformedValue = fieldValue;
            if (key === 'recourse_perc') {
                transformedValue = Number(fieldValue) || ''; 
            }
            if (key === 'recourse_structure') {
                const keyForValue = Array.from(RECOURSE_STRUCTURE.entries()).find(([key, val]) => val === fieldValue)?.[0];
                transformedValue = keyForValue || ''; 
            }
            if (key === 'security_type') {
                const keyForValue = Array.from(SECURITY_TYPES.entries()).find(([key, val]) => val === fieldValue)?.[0];
                transformedValue = keyForValue || ''; 
            }
            if (key === 'security_basis') {
                const keyForValue = Array.from(SECURITY_BASIS.entries()).find(([key, val]) => val === fieldValue)?.[0];
                transformedValue = keyForValue || ''; 
            }
             if (key === 'effective_date') {
                transformedValue = fieldValue ? moment(fieldValue, "YYYY-MM-DD") : null;
            }
            acc[key] = Form.createFormField({
                value: transformedValue
            });
            return acc;
        }, {});
    }
})(RetailerRiskControlForm);